import React from 'react';
import DialogMessage from '../../Dialog';
import { renderToString } from 'react-dom/server'
import { prettyDate } from '../../../utils/date';

const quotasDatesIssues = (data) => {
    return (
        <>
            <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}}>
            {data?.message}
            </strong>
            <hr />
            <table 
               data-cy="table-issues"
               id="table-issues"
               style={{width: '100%'}}>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'center' }}>Data</th>
                        <th style={{ textAlign: 'center' }}>Reservado</th>
                        <th style={{ textAlign: 'center' }}>Distribuido</th>
                        <th style={{ textAlign: 'center' }}>Planta</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data?.data?.map((d, index) => (
                        <tr key={index}>
                            <td style={{ textAlign: 'center' }}>{prettyDate(d?.date)}</td>
                            <td style={{textAlign: 'center'}}>{d?.reserved}</td>
                            <td style={{ textAlign: 'center' }}>{d?.distributed}</td>
                            <td style={{ textAlign: 'center' }}>{d?.plant}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

const ModalQuotasDatesIssues = ({data, ...props}) => {
    const {isOpen, closeReadingNotificationDialog} = props
    const table = renderToString(quotasDatesIssues(data))

    return <DialogMessage
                isOpen={isOpen}
                subject={""}
                data-cy="issues-feedback"
                id="issues-feedback"
                closeReadingNotificationDialog={closeReadingNotificationDialog}
                message={table}
            >
    </DialogMessage>
}

export default ModalQuotasDatesIssues;
